import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Form.scss";
import GoogleLoginButton from "../Google/GoogleLogin";
import axios from "axios";
import { toast } from "react-toastify";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(300); 
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


const handleForgotPassword = async () => {
  if (!email) return toast.warning("Please enter your email address.");
  await axios.post('/forgot-password', { email });
    toast.success('Check your email for reset link.');
};


  const handleSave = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.warning("Please fill all fields!!");

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      if (res.ok) {
        // Send OTP
        const otpRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        const data = await otpRes.json();
        setLoading(false);
        if (otpRes.ok) {
          setOtpSent(true);
          setToken(data.token);
          setTimer(300);
         toast.success ("OTP sent to your email!");
        } else {
          toast.error(data.error || "Failed to send OTP");
        }
      } else {
       toast.error("Invalid email or password!");
      }
    } catch (err) {
      console.error("Error during login/otp:", err);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) return toast.warning("Enter the OTP");

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, token }),
      });

      const data = await res.json();
      if (res.ok) {
        localStorage.setItem("loginSuccess", true);
        navigate("/");
        window.location.reload();
      } else {
        toast.warning(data.error || "Invalid OTP");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
    }
  };

  const resendOtp = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setToken(data.token);
        setTimer(300);
        toast.success("New OTP sent to your email!");
      } else {
       toast.error(data.error || "Failed to resend OTP");
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
      toast.error("Error resending OTP");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    navigate("/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    document.body.classList.add("login-open");

    return () => {
      document.body.style.overflow = "auto";
      document.body.classList.remove("login-open");
    };
  }, []);

  useEffect(() => {
    if (otpSent && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <>
      {isOpen && <div className="overlay" onClick={handleClose}></div>}
      {isOpen && (
        <div className="page">
          <div className="form-container">
            <span className="close-btn" onClick={handleClose}>
              &times;
            </span>
            <h2>{otpSent ? "Enter OTP" : "Login"}</h2>
            <form onSubmit={(e) => e.preventDefault()}>
              {!otpSent ? (
                <>
                  <div className="form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Password:</label>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      required
                    />
                  </div>
                  <div className="password-options">
                    <span style={{display:"flex", alignItems:"center", gap:"5px"}}>
                    <input type="checkbox"  onClick={()=>setShowPassword(!showPassword)} />
                    Show Password
                    </span>
                  <span type="button" onClick={()=>handleForgotPassword(email)} className="forgot-password">
                    Forgot Password?
                  </span>
                  </div>
                  <button onClick={handleSave}>{loading?("Verifying..."):("Login")}</button>
                  <h3 style={{color:"white", margin:" 15px"}}>or</h3>
                  <GoogleLoginButton />

                  <p style={{ marginTop: "10px" }}>
                    Don't have an account? <a href="/signup">Sign up</a>
                  </p>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <label>Enter OTP (expires in {formatTime(timer)}):</label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="6-digit OTP"
                      maxLength={6}
                      required
                    />
                  </div>
                  <button onClick={handleVerifyOtp} disabled={timer <= 0}>
                    Verify OTP
                  </button>
                  {timer <= 0 && (
                    <button type="button" onClick={resendOtp} style={{ marginTop: "10px" }}>
                      Resend OTP
                    </button>
                  )}
                </>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
